import React, { useEffect, useState } from "react";
import { Card, Col, Row, Button, Form, InputGroup } from "react-bootstrap";
import Switch from "react-switch";
import { connect, useSelector } from "react-redux";
import { getGACode, updateGASetting } from "../../actions/setting-action";
import useInput from "../hooks/useInput";
import Loading from "../common/Loading";
import { toast } from "react-toastify";
import copy from "copy-to-clipboard";
import "./SecurityPanel.scss";
import { useTranslation } from "react-i18next";
import CustomSwitch from "../bots/new-bot/modules/CustomSwitch";
import { getUserRegistrationCount, unregisterBiometric } from "../../actions/biometric-action";
import useWebAuthn from "../../hooks/useWebAuthn";

const SecurityPanel = (props) => {
  const { getGACode, updateGASetting,getUserRegistrationCount,unregisterBiometric } = props;
  const { register, isRegistering } = useWebAuthn();
  const {t} = useTranslation()
  const [isOn, setIsOn] = useState(false);
  const [loading, setLoading] = useState(false);
  const gaCode = useSelector((state) => state.settings.gaCode) || "";
  const gaQrCode = useSelector((state) => state.settings.gaQrCode) || "";
  const gaEnabled = useSelector((state) => state.settings.gaEnabled) || false;
  const bioEnabled = useSelector((state) => state.settings.bioEnabled) || false;
  const [code, bindCode, resetCode] = useInput("");
  useEffect(() => {
    getGACode();
    getUserRegistrationCount();
  }, []);
  useEffect(() => {
    setIsOn(gaEnabled);
  }, [gaEnabled]);
  const clickUpdateGASetting = () => {
    setLoading(true);
    updateGASetting(code, isOn ? 1 : 0)
      .then(() => {
        setLoading(false);
        resetCode();
        toast.success(
          `Google Authenticator has been ${isOn ? "enabled" : "disabled"}`
        );
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  };

  const clickCopy = () => {
    copy(gaCode);
    toast.success("Copied code.");
  };
  const clickUnregister = () => {
    setLoading(true);
    unregisterBiometric().then((res)=>{
        setLoading(false);
        toast.success(res.message);
    }).catch((err)=>{
      setLoading(false);
      toast.error(err.message);
    })
   
  };
  return (
    <Loading show={loading} onHide={() => setLoading(false)}>
     <div className="setting-general-content">
        <Row>
          <Col>
            <h5>{t("google-auth")}</h5>
            <p>{gaEnabled ? t("2fa-enabled") : t("2fa-disabled")}</p>
          </Col>
          <Col className="text-right pr-5">
             <CustomSwitch checked={isOn} onChange={setIsOn}></CustomSwitch>
          </Col>
        </Row>
        {!gaEnabled && isOn && (
          <div>
            <hr />
            <div style={{ marginTop: 30 }}>
              <h5>{t("instruction")}</h5>
              <br />
              <p>1. {t("2fa-instruction")}</p>
              <br></br>
              <p style={{ paddingLeft: 30 }}>
                <a
                  href="https://apps.apple.com/vn/app/google-authenticator/id388497605"
                  target="_blank"
                  style={{ marginRight: 30 }}
                >
                  <span className="appstore-item">
                    <img
                      src="/images/icons/apple-white.png"
                      alt=""
                      width={20}
                      height={25}
                    />
                    <span className="appstore-text">Appstore</span>
                  </span>
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US"
                  target="_blank"
                >
                   <span className="appstore-item">
                    <img
                      src="/images/google.png"
                      alt=""
                      width={20}
                      height={25}
                    />
                    <span className="appstore-text">Google Play</span>
                  </span>
                </a>
              </p>
              <p>
              <br></br>
                2. {t("2fa-instruction-2")}
              </p>
              <div style={{ marginBottom: 20 }}>
                <div>
                  <img src={gaQrCode} width={200} />
                </div>
                <Row>
                  <Col xs={6}>
                    <div className="d-flex justify-content-between align-items-center">
                      <div><Form.Control value={gaCode} disabled /></div>
                      <div> <Button variant="" onClick={clickCopy} className="blue-button">
                          Copy
                        </Button></div>
                      
                    </div>
                  </Col>
                </Row>
              </div>
              <p>3. {t("2fa-instruction-3")}</p>
              <Row>
                <Col xs={6}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div><Form.Control {...bindCode} /></div>
                    <div> <Button variant="" onClick={clickUpdateGASetting} className="blue-button">
                        {t("submit")}
                      </Button></div>
                    
                    
                  </div>
                </Col>
              </Row>
              <br />
            </div>
          </div>
        )}
        {gaEnabled && !isOn && (
          <div>
            <br />
            <Col xs={6}>
                  <p>{t("2fa-instruction-4")}</p>
                  <div className="d-flex justify-content-between align-items-center mt-4">
                    <div><Form.Control {...bindCode} /></div>
                    <div> <Button variant="" onClick={clickUpdateGASetting} className="small-btn">
                        {t("submit")}
                      </Button></div>
                    
                    
                  </div>
                </Col>
          </div>
        )}
        <Row>
        <Col>
            <h5>{t("Biometric Registration")}</h5>
          </Col>
          <Col className="text-right pr-5">
          {window.PublicKeyCredential && window.isSecureContext ? (
            bioEnabled==0?
            <button className="blue-button small" onClick={register} disabled={isRegistering}>
              {isRegistering ? 'Enabling...' : 'Register Biometric'}
            </button>
            :<>
             <button className="blue-button small" onClick={()=>clickUnregister()} disabled={isRegistering}>
              {isRegistering ? 'disabling...' : 'Unregister Biometric'}
            </button>
            </>
          ) : (
            <p>Biometric login not supported on this browser.</p>
          )}
          </Col>
        </Row>
      </div>
    </Loading>
  );
};

export default connect(null, { getGACode, updateGASetting,getUserRegistrationCount,unregisterBiometric })(SecurityPanel);
